import React from 'react';
import { hot } from 'react-hot-loader';
import { restrictedType } from '../../../utils/restrict';
import s from './Spacer.scss';

const Spacer = ({ content, attrs, setup, inlineCategoryContent = false }) => {
	const restrictType = restrictedType(setup, attrs);
	return <div className={[s.spacer, (inlineCategoryContent ? s.spacer__inlineCategoryContent : null), (restrictType === 'mobile' ? s.spacer__mobile : null)].join(' ')} style={{ height: `${content.height || 100}px` }} />;
};

export default hot(module)(Spacer);
